<template>
  <div class="home">

    <div class="menu-wrapper">
      <a-popover placement="rightTop" v-model="visible" trigger="click" overlayClassName="home-person-card">
        <template slot="content">
          <div class="user-top">
            <div class="user-avatar">
              <abs-avatar :url="userInfo.avatar" :size="60" :name="userInfo.name"/>
              <img v-if="userInfo.genderDesc"
                :src="userInfo.genderDesc === '男' ? require('@/assets/home/man.png') : userInfo.genderDesc === '女' ? require('@/assets/home/woman.png') : ''" />
            </div>
            <div class="user-name">
              <div class="user-name-title">{{ userInfo.name }}</div>
              <div class="user-name-text">{{ companyName }}</div>
            </div>
          </div>
          <div class="user-info">
            <div class="user-info-text"><span>工号：</span>{{ userInfo.code }}</div>
            <div class="user-info-text"><span>部门：</span>{{ userInfo.orgName }}{{ userInfo.label ? ' · ' + userInfo.label : '' }}</div>
            <div class="user-info-text"><span>手机号：</span>{{ userInfo.phone }}</div>
          </div>
          <div class="bottom-btn">
            <div class="button" @click="handleLogoutClick">退出登录<a-icon type="right" /></div>
          </div>
        </template>
<!--        <div class="avatar">{{ userInfo.name.substr(0, 1) }}</div>-->
        <abs-avatar :url="userInfo.avatar" :name="userInfo.name"/>
      </a-popover>

      <div class="bar-list">
        <div @click="handleBarClick('MessageIndex')" class="bar" :class="{ active: activeItem === 'MessageIndex' }">
          <a-badge :count="$store.getters.unreadMessageNum">
            <img :src="require('@/assets/home/icon-news.svg')" alt="" />
            <div class="bar-list-text">消息</div>
          </a-badge>
        </div>
        <div @click="handleBarClick('WorkHomeIndex')" class="bar" :class="{ active: activeItem === 'WorkHomeIndex' }">
          <img :src="require('@/assets/home/icon-applys.svg')" alt="" />
          <div class="bar-list-text">工作台</div>
        </div>
        <div @click="handleBarClick('ContactsIndex')" class="bar" :class="{ active: activeItem === 'ContactsIndex' }">
          <img :src="require('@/assets/home/icon-addresss.svg')" alt="" />
          <div class="bar-list-text">通讯录</div>
        </div>
        <div @click="handleBarClick('PersonIndex')" class="bar" :class="{ active: activeItem === 'PersonIndex' }">
          <img :src="require('@/assets/home/icon-person.svg')" alt="" />
          <div class="bar-list-text">个人中心</div>
        </div>
      </div>

      <div class="bar-bottom">
        <div @click="handleAdminClick" class="bar" v-if="info.isAdmin === 1 || userInfo.isAdmin === 1 || isAdminGroup">
          <img :src="require('@/assets/home/company_icon.svg')" alt="" />
          <span>管理后台</span>
        </div>
      </div>
    </div>

    <div class="content-wrapper">
      <keep-alive>
        <workplace-view v-show="isWork" />
      </keep-alive>
      <keep-alive :exclude="['PersonIndex']">
        <router-view v-if="!isWork" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import WorkplaceView from '@/views/home/workplace/WorkplaceView.vue'
import { mapGetters } from "vuex"
import Watermark from '@/utils/waterMark.js'
import { getCompanySetting } from "@/api/config"
import AbsAvatar from "@/components/ambition/AbsAvatar.vue";
export default {
  name: 'HomeView',
  components: {
    WorkplaceView,
    AbsAvatar
  },
  data() {
    return {
      visible: false,
      companyName: undefined,
      messageBadge: 0,
    }
  },
  computed: {
    ...mapGetters(['userInfo','info', 'isAdminGroup']),
    isWork() {
      return this.$route.name === 'WorkHomeIndex' || this.$route.meta.type === 'app'
    },
    activeItem() {
      if (this.isWork) {
        return 'WorkHomeIndex'
      } else if (this.$route.path.indexOf('/home/message') >= 0) {
        return 'MessageIndex'
      } else if (this.$route.path.indexOf('/home/contacts') >= 0) {
        return 'ContactsIndex'
      } else if (this.$route.path.indexOf('/home/person') >= 0) {
        return 'PersonIndex'
      }
      return 'MessageIndex'
    }
  },
  methods: {
    getCompanySetting() {
      getCompanySetting().then(res => {
        if (res.success) {
          this.companyName = res.data['company_name'];
        }
      })
    },
    handleAdminClick() {
      let url = this.$router.resolve({ name: "AdminIndex", });
      window.open(url.href, '_blank');
    },
    handleLogoutClick() {
      this.visible = false
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.$store.dispatch('Logout').then(() => {
            location.reload()
          })
        },
        onCancel() {
        }
      })
    },
    handleBarClick(routeName) {
      if (routeName === 'WorkHomeIndex') {
        if (this.$store.getters.currentTab) {
          this.$router.push({ name: this.$store.getters.currentTab.code })
          return
        }
      }
      if (routeName === 'ContactsIndex') {
        Watermark.set(this.userInfo.name + this.companyName ? '-' + this.companyName : '')
      } else {
        Watermark.set('')
      }
			this.$router.push({name: routeName})
		},
	  handleImMessage() {
			this.$store.dispatch('GetUnreadMessageNum')
	  },
	},
	created() {
		window.addEventListener('imMessage', this.handleImMessage)
		this.getCompanySetting()
		this.$store.dispatch('GetUnreadMessageNum')
	}
}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  .menu-wrapper {
    width: 60px;
    background-color: #3e7dff;
    box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.1);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .avatar {
      margin: 20px 0;
      font-weight: 700;
      cursor: pointer;
      /deep/.avatar-name {
        background: #fff;
        color: #3e7dff;
        font-size: 16px !important;
      }
    }

    .bar-list {
      display: flex;
      flex: 1;
      flex-direction: column;

      .bar {
        width: 50px;
        height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;
        color: rgb(216, 229, 255);
        border-radius: 3px;
        font-size: 12px;
        line-height: normal;
        padding: 6px;

        .bar-list-text {
          zoom: 0.85;
          white-space: nowrap;
          opacity: 0.8;
        }

        img {
          margin-bottom: 3px;
          opacity: 0.8;
        }

        &.active {
          background: rgba(255, 255, 255, .2);
          color: #fefefe;

          .bar-list-text {
            opacity: 1;
          }

          img {
            opacity: 1;
          }
        }
        &:hover {
          background: rgba(255, 255, 255, .1);
        }
      }

      .ant-badge {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100%;

        /deep/.ant-badge-count {
          background-color: #ff4f26;
          box-shadow: none;
        }
      }
    }

    .bar-bottom {
      .bar {
        padding: 6px;
        width: 50px;
        height: 50px;
        //background: rgba(255,255,255,.2);
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #fff;
        font-size: 12px;
        opacity: 0.8;

        &:hover {
          background: rgba(255,255,255,.1);
        }

        img {
          height: 19px;
          margin-bottom: 3px;
        }

        span {
          zoom: 0.85;
          white-space: nowrap;
        }
      }
    }
  }

  .content-wrapper {
    display: flex;
    flex: 1;
  }
}

.home-person-card {
  .user-top {
    display: flex;
    align-items: center;
    background: url("~@/assets/home/person_card_bg.png");
    padding: 0 20px;
    width: 340px;
    height: 130px;

    .user-avatar {
      width: 90px;
      height: 90px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 100%;
      position: relative;
      padding: 14px;

      /deep/.ant-avatar {
        background: #fff !important;
        color: #3e7dff !important;
        font-size: 24px !important;
      }

      img {
        position: absolute;
        right: 12px;
        bottom: 12px;
      }
    }

    .user-name {
      margin-left: 20px;
      color: #fff;

      .user-name-title {
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0px;
        margin-bottom: 16px;
      }

      .user-name-text {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0px;
      }
    }
  }

  .user-info {
    border-bottom: 1px #ececec solid;
    padding: 15px 20px;

    .user-info-text {
      font-size: 14px;
      line-height: 32px;
      letter-spacing: 0px;
      color: #787889;

      span {
        color: #a5a5a7;
        display: inline-block;
        width: 60px;
      }
    }
  }

  .bottom-btn {
    padding: 10px 20px;

    .button {
      line-height: 40px;
      background-color: #ffffff;
      border-radius: 3px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #5e5e65;

      &:hover {
        color: #a5a5a7;
      }
    }
  }
}
</style>
<style lang="less">
.home-person-card {
  .ant-popover-arrow {
    border-color: #46a0ff !important;
  }

  .ant-popover-inner-content {
    padding: 0;
  }
}
</style>
